// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { useCallback } from 'react';
import { getIltCourseAttendRecord, updateIltCourseAttend } from '../../apis/iltCourse';
import { AxiosError } from 'axios';

export function getIltCourseAttendHistory(id: number): any {
  const result = getIltCourseAttendRecord(id)
    .then((response) => {
      return response.data;
    })
    .catch((error: AxiosError) => {
      const message = error.response?.data || 'Unhandled Error';
      if (message.includes('message') && message.includes('type')) {
        return JSON.parse(message).message;
      }
      return message;
    })
  return result;
}

export function updateIltCourseAttendRecord(id: number, type: string): any {
  const result = updateIltCourseAttend(id, { type })
    .then((response) => {
      return response.data;
    })
    .catch((error: AxiosError) => {
      const message = error.response?.data || 'Unhandled Error';
      if (message.includes('message') && message.includes('type')) {
        return JSON.parse(message).message;
      }
      return message;
    })
  return result;
}
